import React from 'react';
import { render } from 'react-dom';
import { usrObjMaker, RouteWhenAuthed } from './helper/helper.js';
import { base, editUserProfile } from './helper/base-helper.js';
import { Switch } from 'react-router';
import { BrowserRouter, Route } from 'react-router-dom';

import '../node_modules/semantic-ui-css/semantic.min.css';
import './css/actioncy.css';

import About from './components/About';
import AuthContainer from './components/AuthContainer';
import MenuBar from './components/MenuBar';
import ResultScrn from './components/ResultScrn';
import SearchScrn from './components/SearchScrn';

import AdminContainer from './components/protected/AdminContainer';
import Profile from './components/protected/Profile';
import NotificationCentre from './components/protected/NotificationCentre';


class Root extends React.Component {
  constructor() {
    super();

    this.authHandler = this.authHandler.bind(this);
    this.profileUpdater = this.profileUpdater.bind(this);
    this.getUserRole = this.getUserRole.bind(this);

    this.state = {}
  }

  componentDidMount() {
    //calling firebase to listen auth state
    base.onAuth((user) => {
      this.authHandler(user);
    });
  }

  //callback required for onAuth,
  authHandler(user) {
    if (user) {
      const usrObj = usrObjMaker(user);
      editUserProfile(usrObj);
      this.getUserRole(user.uid);
      this.setState({user: usrObj})
    } else {
      this.setState({user: null})
    }
  }

  getUserRole(uid) {
    base.listenTo(`_userRoles/${uid}`, {
      context: this,
      asArray: false,
      then(rolesData) {
        this.setState({
          user: {
            ...this.state.user,
            role: rolesData
          }
        })
      }
    })
  };

  // submit handler of the Profile component to lift up state after profile changed
  profileUpdater() {
    const user = base.auth().currentUser;
    const usrObj = usrObjMaker(user);
    this.setState({user: usrObj});
  }

  render() {

    const routes = [
      { path: '/',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: SearchScrn
      },
      { path: '/about',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: About
      },
      { path: '/login',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: AuthContainer
      },
      { path: '/profile',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: () => <RouteWhenAuthed user={this.state.user} profileUpdater={this.profileUpdater} component={Profile} />
      },
      { path: '/notifications',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: () => <RouteWhenAuthed user={this.state.user} component={NotificationCentre} />
      },
      { path: '/admin',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: () => <RouteWhenAuthed user={this.state.user} component={AdminContainer} />
      },
      { path: '/:channelURL/:actionURL',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: (pathname) => <ResultScrn {...pathname} user={this.state.user}/>
      },
      { path: '/:channelURL',
        exact: true,
        menubar: (pathname) => <MenuBar {...pathname} user={this.state.user}/>,
        main: (pathname) => <SearchScrn urlQuery={pathname.match.params.channelURL} />
      },
    ]

    return (
      <BrowserRouter>
        <div>
          <Switch>
          {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.menubar}
              />
            ))}
          </Switch>
          <Switch>
          {/* embedding required to make 404 happening. */}
            {
              routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  component={route.main}
                />
              ))
            }
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

render(
  <Root/>, document.querySelector('#root'));



// WEBPACK FOOTER //
// ./src/index.js